export const GEOCODE_CONFIG = {
	apiKey: 'AIzaSyA5XAbTcjkQukhTS4d-AHduaAEkHFiXgNs',
};

export default GEOCODE_CONFIG;
